$('.main-nav__link').click(function (e) {
  e.preventDefault();

  var submenu  = $(this).data('target');

  $('.main-nav__link').removeClass('main-nav__link--selected');
  $('.main-nav__submenu').hide();

  $(this).toggleClass('main-nav__link--selected');
  $(submenu).toggle();
});

$(document).on('click', function(e) {
   $clicked = $(e.target);

   if (
     !$clicked.is('.main-nav__link') && $('.main-nav__link').has(e.target).length == 0 &&
     !$clicked.is('.main-nav__submenu') && $('.main-nav__submenu').has(e.target).length == 0
   ) {
      $('.main-nav__link').removeClass('main-nav__link--selected');
      $('.main-nav__submenu').hide();
   }
});
